import { UploadStatus } from '../enums';

import type { IGame, IVideo } from '../types';

export const MOCK_GAMES: IGame[] = [
  {
    id: 'male',
    entity_type: 'mobile',
    name: 'PUBG MOBILE MALE',
    cover: 'https://ogdb-cdn.intlgame.cn/pic_by_handle/pubg.png',
  },
  {
    id: 'female',
    entity_type: 'mobile',
    name: 'PUBG MOBILE FEMALE',
    cover: 'https://ogdb-cdn.intlgame.cn/pic_by_handle/pubg.png',
  },
];

export const EXAMPLES_VIDEOS: IVideo[] = [
  {
    uuid: 'uuid1',
    status: UploadStatus.Success,
    origin_video_name: 'demo_1',
    origin_video_time: '14',
    origin_video: '/video_fusion/motion_capture/examples/demo_1.mp4',
    origin_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_1.mp4?q-sign-algorithm=sha1&q-sign-time=1701312195;1732416195&q-key-time=1701312195;1732416195&q-header-list=&q-url-param-list=&q-signature=ec88b028596a2a0d5c644e5a791b8507c40f393d',
    result_video: '/video_fusion/motion_capture/examples/demo_1.mp4',
    result_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_1.mp4?q-sign-algorithm=sha1&q-sign-time=1701312195;1732416195&q-key-time=1701312195;1732416195&q-header-list=&q-url-param-list=&q-signature=ec88b028596a2a0d5c644e5a791b8507c40f393d',
    concat_video: '/video_fusion/motion_capture/examples/demo_1.mp4',
    concat_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_1.mp4?q-sign-algorithm=sha1&q-sign-time=1701312195;1732416195&q-key-time=1701312195;1732416195&q-header-list=&q-url-param-list=&q-signature=ec88b028596a2a0d5c644e5a791b8507c40f393d',
    concat_video_cover:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_1_0.jpg?q-sign-algorithm=sha1&q-sign-time=1701312284;1732416284&q-key-time=1701312284;1732416284&q-header-list=&q-url-param-list=&q-signature=86981a6eb5f659f88d66bfefefb39ec4073c4d41',
    result_msg: '',
    create_time: '2023-11-30 13:28:50',
  },
  {
    uuid: 'uuid2',
    status: UploadStatus.Success,
    origin_video_name: 'demo_2',
    origin_video_time: '16',
    origin_video: '/video_fusion/motion_capture/examples/demo_2.mp4',
    origin_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_2.mp4?q-sign-algorithm=sha1&q-sign-time=1701312347;1732416347&q-key-time=1701312347;1732416347&q-header-list=&q-url-param-list=&q-signature=68d8f825258e4da43935cbc7db61140e7a01b738',
    result_video: '/video_fusion/motion_capture/examples/demo_2.mp4',
    result_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_2.mp4?q-sign-algorithm=sha1&q-sign-time=1701312347;1732416347&q-key-time=1701312347;1732416347&q-header-list=&q-url-param-list=&q-signature=68d8f825258e4da43935cbc7db61140e7a01b738',
    concat_video: '/video_fusion/motion_capture/examples/demo_2.mp4',
    concat_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_2.mp4?q-sign-algorithm=sha1&q-sign-time=1701312347;1732416347&q-key-time=1701312347;1732416347&q-header-list=&q-url-param-list=&q-signature=68d8f825258e4da43935cbc7db61140e7a01b738',
    concat_video_cover:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_2_0.jpg?q-sign-algorithm=sha1&q-sign-time=1701312355;1732416355&q-key-time=1701312355;1732416355&q-header-list=&q-url-param-list=&q-signature=25d13e4d575ffb38f1e52acb8ad66c50792185e6',
    result_msg: '',
    create_time: '2023-11-30 13:28:50',
  },
  {
    uuid: 'uuid3',
    status: UploadStatus.Success,
    origin_video_name: 'demo_3',
    origin_video_time: '26',
    origin_video: '/video_fusion/motion_capture/examples/demo_3.mp4',
    origin_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_3.mp4?q-sign-algorithm=sha1&q-sign-time=1701312368;1732416368&q-key-time=1701312368;1732416368&q-header-list=&q-url-param-list=&q-signature=04934d2826b6caf681516cf6d65862e4d309384e',
    result_video: '/video_fusion/motion_capture/examples/demo_3.mp4',
    result_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_3.mp4?q-sign-algorithm=sha1&q-sign-time=1701312368;1732416368&q-key-time=1701312368;1732416368&q-header-list=&q-url-param-list=&q-signature=04934d2826b6caf681516cf6d65862e4d309384e',
    concat_video: '/video_fusion/motion_capture/examples/demo_3.mp4',
    concat_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_3.mp4?q-sign-algorithm=sha1&q-sign-time=1701312368;1732416368&q-key-time=1701312368;1732416368&q-header-list=&q-url-param-list=&q-signature=04934d2826b6caf681516cf6d65862e4d309384e',
    concat_video_cover:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_3_0.jpg?q-sign-algorithm=sha1&q-sign-time=1701312379;1732416379&q-key-time=1701312379;1732416379&q-header-list=&q-url-param-list=&q-signature=c3b9b440b0516057d00dd9bde3707f078fb0f131',
    result_msg: '',
    create_time: '2023-11-30 13:28:50',
  },
  {
    uuid: 'uuid4',
    status: UploadStatus.Success,
    origin_video_name: 'demo_4',
    origin_video_time: '16',
    origin_video: '/video_fusion/motion_capture/examples/demo_4.mp4',
    origin_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_4.mp4?q-sign-algorithm=sha1&q-sign-time=1701312389;1732416389&q-key-time=1701312389;1732416389&q-header-list=&q-url-param-list=&q-signature=2237ecbd867b72295466eba3046fe44621913f6b',
    result_video: '/video_fusion/motion_capture/examples/demo_4.mp4',
    result_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_4.mp4?q-sign-algorithm=sha1&q-sign-time=1701312389;1732416389&q-key-time=1701312389;1732416389&q-header-list=&q-url-param-list=&q-signature=2237ecbd867b72295466eba3046fe44621913f6b',
    concat_video: '/video_fusion/motion_capture/examples/demo_4.mp4',
    concat_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_4.mp4?q-sign-algorithm=sha1&q-sign-time=1701312389;1732416389&q-key-time=1701312389;1732416389&q-header-list=&q-url-param-list=&q-signature=2237ecbd867b72295466eba3046fe44621913f6b',
    concat_video_cover:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_4_0.jpg?q-sign-algorithm=sha1&q-sign-time=1701312397;1732416397&q-key-time=1701312397;1732416397&q-header-list=&q-url-param-list=&q-signature=2dbfe6f9c230463001d41428024cb1229de64d8c',
    result_msg: '',
    create_time: '2023-11-30 13:28:50',
  },
  {
    uuid: 'uuid5',
    origin_video_name: 'demo_5',
    status: UploadStatus.Success,
    origin_video_time: '12',
    origin_video: '/motion_capture/examples/demo_5.mp4',
    origin_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_5.mp4?q-sign-algorithm=sha1&q-sign-time=1701312407;1732416407&q-key-time=1701312407;1732416407&q-header-list=&q-url-param-list=&q-signature=1e57e6fdaeb9802a06f25bed1324472f48959b92',
    result_video: '/motion_capture/examples/demo_5.mp4',
    result_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_5.mp4?q-sign-algorithm=sha1&q-sign-time=1701312407;1732416407&q-key-time=1701312407;1732416407&q-header-list=&q-url-param-list=&q-signature=1e57e6fdaeb9802a06f25bed1324472f48959b92',
    concat_video: '/motion_capture/examples/demo_5.mp4',
    concat_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_5.mp4?q-sign-algorithm=sha1&q-sign-time=1701312407;1732416407&q-key-time=1701312407;1732416407&q-header-list=&q-url-param-list=&q-signature=1e57e6fdaeb9802a06f25bed1324472f48959b92',
    concat_video_cover:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_5_0.jpg?q-sign-algorithm=sha1&q-sign-time=1701312415;1732416415&q-key-time=1701312415;1732416415&q-header-list=&q-url-param-list=&q-signature=fb45d53b548d3513d3b4980ee02089e60ad03e12',
    result_msg: '',
    create_time: '2023-11-30 13:28:50',
  },
  {
    uuid: 'uuid6',
    origin_video_name: 'demo_6',
    status: UploadStatus.Success,
    origin_video_time: '10',
    origin_video: '/video_fusion/motion_capture/examples/demo_6.mp4',
    origin_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_6.mp4?q-sign-algorithm=sha1&q-sign-time=1701312424;1732416424&q-key-time=1701312424;1732416424&q-header-list=&q-url-param-list=&q-signature=6d5e9b8320097e1f605575486bb6cb12549f2e55',
    result_video: '/video_fusion/motion_capture/examples/demo_6.mp4',
    result_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_6.mp4?q-sign-algorithm=sha1&q-sign-time=1701312424;1732416424&q-key-time=1701312424;1732416424&q-header-list=&q-url-param-list=&q-signature=6d5e9b8320097e1f605575486bb6cb12549f2e55',
    concat_video: '/video_fusion/motion_capture/examples/demo_6.mp4',
    concat_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_6.mp4?q-sign-algorithm=sha1&q-sign-time=1701312424;1732416424&q-key-time=1701312424;1732416424&q-header-list=&q-url-param-list=&q-signature=6d5e9b8320097e1f605575486bb6cb12549f2e55',
    concat_video_cover:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_6_0.jpg?q-sign-algorithm=sha1&q-sign-time=1701312432;1732416432&q-key-time=1701312432;1732416432&q-header-list=&q-url-param-list=&q-signature=faba611697ef5a97feb923243c1828bbdc1b731b',
    result_msg: '',
    create_time: '2023-11-30 13:28:50',
  },
  {
    uuid: 'uuid7',
    origin_video_name: 'demo_7',
    status: UploadStatus.Success,
    origin_video_time: '10',
    origin_video: '/video_fusion/motion_capture/examples/demo_7.mp4',
    origin_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_7.mp4?q-sign-algorithm=sha1&q-sign-time=1701312439;1732416439&q-key-time=1701312439;1732416439&q-header-list=&q-url-param-list=&q-signature=de7f5c1b80653d6b84bf46ee5c2230992d02b919',
    result_video: '/video_fusion/motion_capture/examples/demo_7.mp4',
    result_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_7.mp4?q-sign-algorithm=sha1&q-sign-time=1701312439;1732416439&q-key-time=1701312439;1732416439&q-header-list=&q-url-param-list=&q-signature=de7f5c1b80653d6b84bf46ee5c2230992d02b919',
    concat_video: '/video_fusion/motion_capture/examples/demo_7.mp4',
    concat_video_url:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_7.mp4?q-sign-algorithm=sha1&q-sign-time=1701312439;1732416439&q-key-time=1701312439;1732416439&q-header-list=&q-url-param-list=&q-signature=de7f5c1b80653d6b84bf46ee5c2230992d02b919',
    concat_video_cover:
      'https://ua-sg-1300342648.cos.ap-singapore.myqcloud.com/video_fusion/motion_capture/examples/demo_7_0.jpg?q-sign-algorithm=sha1&q-sign-time=1701312445;1732416445&q-key-time=1701312445;1732416445&q-header-list=&q-url-param-list=&q-signature=e9668782705fed00700193cd108d4f7e1b21b8f5',
    result_msg: '',
    create_time: '2023-11-30 13:28:50',
  },
];
